// base
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

// style
import { StyledTab, StyledTabContent } from './style';

// library
import { Tabs, Tab } from '@mui/material';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <StyledTabContent sx={{ p: 1 }}>{children}</StyledTabContent>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function props(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

export const BasicTab = ({ labels, items }) => {
  const [value, setValue] = useState(0);

  const handleChange = useCallback(
    (e, newValue) => {
      setValue(newValue);
    },
    [value]
  );

  return (
    <StyledTab sx={{ width: '100%' }}>
      <Tabs value={value} onChange={handleChange} sx={{ p: 1, borderBottom: '1px solid e6e6e6' }}>
        {labels.map((label, i) => (
          <Tab key={i} label={label} {...props(i)} />
        ))}
      </Tabs>
      {items.map((item, i) => (
        <CustomTabPanel key={i} value={value} index={i}>
          {item}
        </CustomTabPanel>
      ))}
    </StyledTab>
  );
};
